export function overduePaymentAlert(proj) {
    let classAlert: string = ""
    let supportPayment: boolean = false;
    if (proj.date) {
        const currentDate: Date = new Date();
        currentDate;
        if (proj.date < currentDate) {
            supportPayment = true;
            let timeDifference = (currentDate.valueOf() - proj.date) / 86400 / 1000;
            if (timeDifference > 1) {
                timeDifference = Math.floor(timeDifference);
            } else {
                timeDifference = 1;
            }
            if (timeDifference >= 10 && timeDifference <= 20) {
                classAlert = "alert1";
            } else
                if (timeDifference >= 21 && timeDifference <= 30) {
                    classAlert = "alert2";
                } else
                    if (timeDifference >= 31 && timeDifference <= 40) {
                        classAlert = "alert3";
                    } else
                        if (timeDifference >= 41 && timeDifference <= 59) {
                            classAlert = "alert4";
                        } else
                        if (timeDifference >= 60) {
                            classAlert = "alert5";
                        }
            return { classAlert, supportPayment };
        }
    }
}